<template>
  <!-- 提货详情 -->
  <div class="pickUp-detail-view">
    <!-- 标签 -->
    <div class="pickUp-number">
      <div class="text">NO：<span>{{ dataForm.number }}</span></div>
      <div class="time">{{ dataForm.createTime }}</div>
    </div>

    <div class="logisticsInfo">
      <h3>提货信息</h3>

      <el-row :gutter="20">
        <el-col :span="8">业务类型：<span>{{ dataForm.bizTypeGroupDesc }}</span></el-col>
        <el-col :span="8">提货时间：<span>{{ dataForm.deliveryTime }}</span></el-col>
        <el-col :span="8">件数：<span>{{ dataForm.packedQty }}</span></el-col>
        <el-col :span="8">卡板数：<span>{{ dataForm.cardBoard }}</span></el-col>
        <!-- <el-col :span="8">关联订单号：<span>{{ dataForm.custOrderNo }}</span></el-col> -->
      </el-row>

      <div class="supplierName">
        <div class="supplier">
          发货公司
        </div>
        <p>{{ dataForm.companyName }}</p>
      </div>

      <div class="receivingAddress">
        <ab-svg name="dingwei"></ab-svg>
        {{ dataForm.addressContent }}/{{ dataForm.linkMan }}/{{ dataForm.linkPhone }}
      </div>

      <el-alert
        v-if="dataForm.remarks"
        :title="'备注：' + dataForm.remarks"
        type="warning"
        :closable="false"
      />

      <!-- 司机资料 -->
      <template v-if="[4, 5].includes(dataForm.status)">
        <h3 class="driver-hd">
          司机资料
          <span style="font-size:14px;color:#f56c6c"></span>
        </h3>
        <el-row :gutter="20">
          <el-col :span="8">大陆车牌：<span>{{ dataForm.plateNumber }}</span></el-col>
          <el-col :span="8">司机：<span>{{ dataForm.driverName }}</span></el-col>
          <el-col :span="8">电话号码：<span>{{ dataForm.telCn }}</span></el-col>
          <el-col :span="8">香港车牌号：<span>{{ dataForm.plateNumberHk }}</span></el-col>
          <el-col :span="8">身份证号：<span>{{ dataForm.idCardNo }}</span></el-col>
          <el-col :span="8">车柜型：<span>{{ getDriverCarTypeDesc(dataForm.driverCarType) }}</span></el-col>
          <el-col :span="8">出车类型：<span>{{{'01': '国内车提货', '05': '港车提货'}[dataForm.vehicleType]}}</span></el-col>
          <el-col :span="8">六联单：<span>{{ dataForm.sixLinkedNo }}</span></el-col>
          <el-col :span="8">集装箱号：<span>{{ dataForm.containerNo }}</span></el-col>
          <el-col :span="8">封条号：<span>{{ dataForm.sealNo }}</span></el-col>
          <el-col :span="8">备注：<span>{{ dataForm.driverRemarks }}</span></el-col>
        </el-row>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pickUp-detail-view',
  props: {
    options: {
      type: Object,
      default () {
        return {}
      }
    },

    dataForm: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data() {
    return {

    }
  },

  computed: {

  },

  mounted() {
    
  },

  methods: {
    getDriverCarTypeDesc(type) {
      if (this.options.carType && this.options.carType.length) {
        const find = this.options.carType.find(e => e.value === type)
        return find ? find.label : ''
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
.pickUp-detail-view {
  position: relative;
  padding: 35px 0 0 0;
  text-align: left;
  border-top: 1px solid #f0f2f5;
  color: #000000;
  // min-height: 800px;
  h3 {
    font-size: 18px;
    margin-bottom: 32px;
  }

  .logisticsInfo {
    .el-col.el-col-8 {
      margin-bottom: 34px;
      font-size: 14px;
    }
    .supplierName {
      width: 100%;
      display: flex;
      padding: 0 0 20px;
      border-bottom: 1px solid #f0f2f5;
      line-height: 24px;
      .supplier {
        padding: 5px 12px;
        height: 24px;
        font-size: 14px;
        line-height: 14px;
        border-radius: 4px;
        background-color: #f0f2f5;
      }
      p {
        font-size: 22px;
        font-weight: bold;
        margin-left: 20px;
      }
    }
    .receivingAddress {
      font-size: 14px;
      font-weight: 400;
      margin: 18px 0 38px 0;
      .icon-svg {
        width: 11px;
        height: 16px;
        vertical-align: bottom;
      }
    }
    .el-alert {
      margin: 38px 0 36px;
    }
    .driver-hd {
      margin-top: 35px;
    }
  }

  .footer {
    position: absolute;
    bottom: 0;
    margin-top: 20px;
    padding: 20px 0;
    width: 100%;
    text-align: center;
  }

  //标签
  .pickUp-number {
    position: absolute;
    width: 200px;
    top: 0px;
    right: 0px;
    border-radius: 0 0 8px 8px;
    background-color: #f2f7ff;
    font-size: 14px;
    text-align: center;
    .text {
      padding: 10px 0;
    }
    .time {
      padding: 10px 0;
    }
  }
}
</style>